export {default} from "./Socials";
